import React from 'react';

/* Logo officiel complet : l'icône Afrique au-dessus, TRIBE dessous, sur fond
   transparent. Jamais réduit au mot TRIBE ni placé en ligne à côté d'un
   texte. Proportions des fichiers : 130 × 184.
   - public/assets/applogo.svg : version d'origine (même fichier que le
     back-office), contours et lettres en noir, pour un fond clair ;
   - public/assets/applogo-ecru.svg : même dessin, seules les lettres TRIBE
     passées en écru #F2E8D4 ; les contours noirs de l'Afrique et du pin
     restent noirs. Posé directement sur l'indigo (navigation, écrans
     d'accès). */
const L = 130, H = 184;

/** Logo complet ; dimensionné par sa largeur, ou par sa hauteur quand elle est donnée. */
export const LogoTribe: React.FC<{ largeur?: number; hauteur?: number; surIndigo?: boolean }> = ({ largeur = 72, hauteur, surIndigo = false }) => {
  const h = hauteur ?? Math.round((H * largeur) / L);
  const l = hauteur ? Math.round((L * hauteur) / H) : largeur;
  return (
    <img src={surIndigo ? '/assets/applogo-ecru.svg' : '/assets/applogo.svg'} alt="Tribe"
      width={l} height={h} style={{ display: 'block' }} />
  );
};

/** Logo en écru directement sur l'indigo, sans plaque ni fond, avec sa mention en
    JetBrains Mono orange dessous : 96 px de haut dans la barre, 120 px sur les écrans d'accès. */
export const MarqueTribe: React.FC<{ hauteur?: number; mention?: string; alignement?: 'center' | 'flex-start' }> = (
  { hauteur = 96, mention = 'PORTAIL CLIENT', alignement = 'center' },
) => (
  <div className="marque" style={{ alignItems: alignement }}>
    <LogoTribe hauteur={hauteur} surIndigo />
    {mention && <span className="marque__sous-titre">{mention}</span>}
  </div>
);

export default LogoTribe;
